import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined);
  const [restaurant, setRestaurant] = useState(null);

  useEffect(() => {
    // Session lives in an httpOnly cookie, not localStorage.
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data.user);
        setRestaurant(r.data.restaurant);
      })
      .catch(() => setUser(null));
  }, []);

  const saveSession = useCallback((data) => {
    setUser(data.user);
    setRestaurant(data.restaurant);
  }, []);

  const logout = useCallback(() => {
    api.post("/auth/logout").catch(() => {});
    setUser(null);
    setRestaurant(null);
  }, []);

  const value = useMemo(
    () => ({ user, restaurant, saveSession, logout }),
    [user, restaurant, saveSession, logout]
  );

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
